// extracted by mini-css-extract-plugin
var _1 = "CompanyLogo-moduleCompanyLogo__JTc6u";
var _2 = "CompanyLogo-modulecollapsed__D66HG";
var _3 = "CompanyLogo-modulecollapsedLogo__U7qRk";
var _4 = "CompanyLogo-moduleexpanded__UfU53";
var _5 = "CompanyLogo-moduleexpandedLogo__p_9MI";
export { _1 as "CompanyLogo", _2 as "collapsed", _3 as "collapsedLogo", _4 as "expanded", _5 as "expandedLogo" }
